<template>
<v-list class="py-0" v-if="links.length">
  <v-list-item class="grey lighten-3 py-0">
    <v-list-item-icon>

    </v-list-item-icon>
    <v-list-item-content>

    </v-list-item-content>

    <v-list-item-action>

    </v-list-item-action>

    <v-list-item-action>
      <div>
        <span class="font-weight-bold grey--text text--darken-2">Visible</span>
      </div>
    </v-list-item-action>
  </v-list-item>
  <v-divider></v-divider>
  <template v-for="(link,i) in links">
      <v-list-item class="" :key="i">
        <v-list-item-icon>
          <v-icon :color="$helpers.linkColor(link.url)" large>{{$helpers.linkIcon(link.url)}}</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <a class="nolink caption" :href="link.url" target="_blank"><span class="">{{link.url}}</span></a>
        </v-list-item-content>
        <v-list-item-action>

        </v-list-item-action>
        <v-list-item-action>
          <div>
            <v-switch color="green" :false-value="0" :true-value="1" hide-details class="mt-0" inset dense :input-value="link.visible" :disabled="true"></v-switch>
          </div>
        </v-list-item-action>
      </v-list-item>
      <v-divider :key="'d' + i" v-if="i < $store.getters['profile/links'].length-1"></v-divider>
    </template>
</v-list>
</template>
<script>
export default {
  props: ['links'],
  name: "",
  data: () => ({

  })
}
</script>
<style lang="scss" scoped>
</style>
